import { render } from "./FbnLandingPage.vue?vue&type=template&id=b9dd4682"
import script from "./FbnLandingPage.vue?vue&type=script&lang=js"
export * from "./FbnLandingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__